import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { Button } from "@/components/ui/button";
import { Users, Ban, UserCheck } from 'lucide-react';
import StudentDeleteConfirmation from './StudentDeleteConfirmation';
import { useTranslation } from 'react-i18next';

interface Student {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  address?: string;
  belt_level_id?: string;
  join_date?: string;
  is_blocked?: boolean;
}

interface StudentActionsProps {
  selectedStudent: string;
  selectedStudentData?: Student;
  isLoading: boolean;
  onUpdate: (e: React.FormEvent) => Promise<void>;
  onDelete: () => Promise<void>;
  onBlock: () => Promise<void>;
  onUnblock: () => Promise<void>;
}

const StudentActions: React.FC<StudentActionsProps> = ({
  selectedStudent,
  selectedStudentData,
  isLoading,
  onUpdate,
  onDelete,
  onBlock,
  onUnblock
}) => {
  useUiLanguage();
  const { t } = useTranslation('admin');
  return (
    <div className="flex flex-wrap gap-4 pt-4">
      <Button
        type="submit"
        className="bg-red-900 hover:bg-red-800"
        disabled={isLoading}
      >
        <Users className="h-4 w-4 mr-2" />
        {isLoading ? uiText("Updating...") : uiText("Update Student Data")}
      </Button>

      {selectedStudentData?.is_blocked ? (
        <Button
          type="button"
          variant="outline"
          className="border-green-600 text-green-600 hover:bg-green-50"
          onClick={onUnblock}
          disabled={isLoading}
        >
          <UserCheck className="h-4 w-4 mr-2" />
          {t("admin:studentActions.unblockUser")}
        </Button>
      ) : (
        <Button
          type="button"
          variant="outline"
          className="border-orange-600 text-orange-600 hover:bg-orange-50"
          onClick={onBlock}
          disabled={isLoading}
        >
          <Ban className="h-4 w-4 mr-2" />
          {t("admin:studentActions.blockUser")}
        </Button>
      )}

      <StudentDeleteConfirmation
        selectedStudent={selectedStudent}
        selectedStudentData={selectedStudentData}
        onDelete={onDelete}
      />
    </div>
  );
};

export default StudentActions;
